import React, {useContext, useRef} from 'react';
import {PlatipusList} from "./PlatipusList";
import {WIDGET_TYPES, DocumentsExplorer} from "slykit";
import {LoginContext} from "../../app";

/**
 * PLATIPUS specific instance of a Documents Explorer.
 *
 * @returns {null|*}
 * @constructor
 */
export const PlatipusExplorer = () => {
  const isReady = useContext(LoginContext);
  const out = useRef([WIDGET_TYPES.INNOVATION]);

  return (
    <DocumentsExplorer isReady={isReady}
                       dilName={'Covid Pubs'} // FIXME will need to change on the backend before changing this will work
                       listComponent={<PlatipusList/>}
                       widgetOutFilter={out.current}/>
  )
};

